import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { HttpServiceService } from '../../../services/http-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadcrumbComponent } from '../../../elements/breadcrumb/breadcrumb.component';
import { OwnerOverviewComponent } from '../owner-overview/owner-overview.component';
import { DatePipe, NgFor, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-owner-bills',
  imports: [BreadcrumbComponent, OwnerOverviewComponent, NgIf, FormsModule, NgFor, DatePipe],
  templateUrl: './owner-bills.component.html',
  styleUrl: './owner-bills.component.css'
})
export class OwnerBillsComponent {
  breadcrumbList: any;
  private routeSubscription?: Subscription;
  userId: string = '';
  userInvoices: any;
  userProperties: any;
  choosenProperty: string = '';
  private getAllInvoicesSubscription?: Subscription;
  ownerBills: any;
  private getBillImagesSubscription?: Subscription;
  addProperty? : string;

  constructor(private httpService: HttpServiceService, private route: ActivatedRoute, private router: Router) {
    this.routeSubscription = this.route.paramMap.subscribe(params => {
      this.userId = params.get('id') ?? "";
      let userType = params.get('type') ?? "";
      this.breadcrumbList = {
        breadcrumb_path: userType == "owner" ? "Owners" : "Tenants",
        currentURL: 'Bills',
        breadcrumb_url: '/admin/' + (userType == "owner" ? "owners" : "tenants")
      }
    });
  }

  goBackToList(event : any){    
    this.router.navigate([this.breadcrumbList.breadcrumb_url]);
  }

  getUserDetails(data: any) {
    this.userProperties = data["properties"] ?? [];
    let defaultPropertyId = this.userProperties?.length ? this.userProperties[0].uid : "";
    if (defaultPropertyId) {
      this.choosenProperty = defaultPropertyId;
      this.getAllBills(defaultPropertyId);
    }
  }

  getPropertyBills() {
    this.getAllBills(this.choosenProperty);
  }

  getAllBills(propertyId: string) {
    this.getAllInvoicesSubscription = this.httpService.getAllBills(propertyId, 1, 100).subscribe({
      next: (response) => {
        this.ownerBills = response.data["bills"];
      }
    })
  }
  viewInvoice(billId: string) {
    this.getBillImagesSubscription = this.httpService.viewInvoice(billId, this.choosenProperty).subscribe({
      next: (response) => {
        window.open(response.data["link"], '_blank');
      }
    })
  }

  ngOnDestroy() {
    this.routeSubscription?.unsubscribe();
    this.getAllInvoicesSubscription?.unsubscribe();
    this.getBillImagesSubscription?.unsubscribe();
  }

}
